import { render, staticRenderFns } from "./PrefPicker.vue?vue&type=template&id=6b184522&scoped=true"
import script from "./PrefPicker.vue?vue&type=script&lang=js"
export * from "./PrefPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b184522",
  null
  
)

export default component.exports